import { getDefaultShopConfig } from './default';
import { getConditionsFilterConfig } from '../filters/condition';
import * as custom from '../filters/marketplace-custom-config';
import { getSizeFilterConfig } from '../filters/size';
import { getColorFilterConfig } from '../filters/color';
import { getBrandDirectFilterConfig } from '../filters/brandDirect';
import { BuilderSections } from '../../util/builder';

const zulilySizes = [
  '6 Months',
  '12 Months',
  '18 Months',
  '24 Months',
  '2T',
  '3T',
  '4T',
  '5T',
  '6T',
  'XS',
  'S',
  'M',
  'L',
  'XL',
  '1X',
  '2XL',
  '2X',
  '3XL',
  '3X',
  '4XL',
  '4X',
  '5XL',
];

export const zulilyShopConfig = {
  ...getDefaultShopConfig(),
  filters: [
    ...custom.filters,
    getConditionsFilterConfig(),
    getSizeFilterConfig({ sizes: zulilySizes }),
    getColorFilterConfig(),
    getBrandDirectFilterConfig(),
  ],
  builderConfig: {
    sections: {
      [BuilderSections.LandingPageContent]: '8f613ad1f6dc44fd92462c15dbf36bc8',
      [BuilderSections.TopbarContent]: 'c2be1485280748589d9f908f7cf41c46',
    },
  },
};
